import { render, staticRenderFns } from "./DownloadProgress.vue?vue&type=template&id=52e81be4&scoped=true"
import script from "./DownloadProgress.vue?vue&type=script&lang=js"
export * from "./DownloadProgress.vue?vue&type=script&lang=js"
import style0 from "./DownloadProgress.vue?vue&type=style&index=0&id=52e81be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e81be4",
  null
  
)

export default component.exports